<template>
	<div>
		<template v-for="(project, index) in points">
			<li :key="index">
				<span class="icon big warpit_icon_survey"></span>
				<div class="listsText">
					<span class="date">{{ formatDate(project.created_at) }}</span>

					<span v-if="dateValid(project.expiration)">
						<span v-if="project.label === 'Obtained with questioner compliting'">
							<span>{{ $t("profile.complete_survey_text", { 'survey': project.long_name }) }}</span>
							<span class="fallDue">
								{{ $t("profile.points") }}
								{{ $t("profile.expires") }}
								<!-- {{ formatDate(project.expiration) }} -->
								{{ formatDate(addOneYear(project.created_at)) }}
							</span>
						</span>
						<span v-else>
							<span v-if="project.negative !== 1">Odpis točk</span>
							<span v-else>Ročni pripis točk</span>
							<span class="fallDue">Namen: {{ project.label }}</span>
							<span class="fallDue" v-if="project.negative === 1">
								{{ $t("profile.points") }}
								{{ $t("profile.expires") }}
								<!-- {{ formatDate(project.expiration) }} -->
								{{ formatDate(addOneYear(project.created_at)) }}
							</span>
						</span>
					</span>
					<span class="fallDue" v-else>
						{{ $t('profile.expired_at') }}
						<!-- {{ formatDate(project.expiration) }} -->
						{{ formatDate(addOneYear(project.created_at)) }}
					</span>

				</div>
				<span class="points flex" :class="[{ 'positive': project.negative === 1 }, { 'negative': project.negative === -1 }]" v-if="dateValid(project.expiration)">
					<span v-if="project.negative === 1">+{{ formatNumber(project.points) }}</span>
					<span v-else>-{{ formatNumber(project.points) }}</span>
					<span class="icon warpit_icon_loyalty-point"></span>
				</span>
				<span class="points flex" v-else>
					<span>{{ formatNumber(project.points) }}</span>
					<span class="icon warpit_icon_loyalty-point"></span>
				</span>
			</li>
		</template>
	</div>
</template>
<script>
import { formatDate } from "@/helpers";
import { addOneYear } from "@/helpers";
import { formatNumber } from '@/helpers.js';
export default {
	setup() { },
	mounted() { },
	computed: {
	},
	methods: {
		formatDate,
		addOneYear,
		formatNumber,
		dateValid(date) {
			var currentDate = new Date();
			var givenDate = new Date(date);
			if (givenDate > currentDate) {
				return true;
			}
			return false;
		},
	},
	props: {
		points: Array
	}
};
</script>